import React from "react";
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import useUniversitiesList from "../../hooks/useUniversitiesList";

function FilterBar({
  universityId,
  courseId,
  semesterId,
  regulationId,
  setUniversityId,
  setCourseId,
  setSemesterId,
  setRegulationId,
  pageName,
  PurchasesFile,
  regulation,
}) {
  const { universityList, courses, semesters, regulations, loading } =
    useUniversitiesList({});

  const FilterCourse = courses.filter((course) => {
    return course.universityId === universityId;
  });
  return (
    <>
      {" "}
      <Box
        sx={{
          width: {
            md:
              pageName === "Messages"
                ? "80%"
                : "90%" || PurchasesFile === "PurchasedUsers"
                  ? "100%"
                  : "90%",
            xs: "100%",
          },

          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", md: "center" },
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            display: PurchasesFile === "PurchasedUsers" ? "block" : "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* === University Dropdown === */}
          <Grid
            item
            xs={12}
            sm={6}
            md={regulation === "Reports" ? 4 : 3}
            sx={{
              ...(PurchasesFile === "PurchasedUsers" && {
                flexBasis: "100% !important",
                maxWidth: "100% !important",
              }),
            }}
          >
            <FormControl fullWidth size="small">
              <InputLabel>Select University</InputLabel>
              <Select
                value={universityId || ""}
                onChange={(e) => {
                  setUniversityId(e.target.value);
                  setCourseId("");
                  setSemesterId("");
                  if (setRegulationId) setRegulationId("");
                }}
                label="Select University"
                sx={{
                  textAlign: "left",
                  backgroundColor: "#fff",
                }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {universityList.map((u) => (
                  <MenuItem key={u.id} value={u.id}>
                    {u.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* === Course Dropdown === */}
          <Grid
            item
            xs={12}
            sm={6}
            md={regulation === "Reports" ? 4 : 3}
            sx={{
              ...(PurchasesFile === "PurchasedUsers" && {
                flexBasis: "100% !important",
                maxWidth: "100% !important",
              }),
            }}
          >
            <FormControl
              fullWidth
              size="small"
              disabled={pageName === "Messages" && !universityId}
            >
              <InputLabel>Select Course</InputLabel>
              <Select
                value={courseId || ""}
                onChange={(e) => {
                  setCourseId(e.target.value);
                  setSemesterId("");
                  if (setRegulationId) setRegulationId("");
                }}
                label="Select Course"
                sx={{ textAlign: "left", backgroundColor: "#fff" }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>

                {/* Ensure courses is always an array */}
                {(universityId ? FilterCourse : courses)?.map((cou, index) => {
                  return (
                    <MenuItem key={`${cou.id}-${index}`} value={cou.id}>
                      {cou.courseName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          {/* === Regulation Dropdown === */}
          {regulation !== "Reports" && (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              sx={{
                ...(PurchasesFile === "PurchasedUsers" && {
                  flexBasis: "100% !important",
                  maxWidth: "100% !important",
                }),
              }}
            >
              <FormControl fullWidth size="small">
                <InputLabel>Select Regulation</InputLabel>
                <Select
                  value={regulationId || ""}
                  onChange={(e) => {
                    setRegulationId(e.target.value);
                    setSemesterId("");
                  }}
                  label="Select Regulation"
                  sx={{
                    textAlign: "left",
                    backgroundColor: "#fff",
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {regulations
                    .filter((reg) => reg.courseId === courseId)
                    .map((reg) => (
                      <MenuItem key={reg.id} value={reg.id}>
                        {reg.regulationName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          {/* === Semester Dropdown === */}
          <Grid
            item
            xs={12}
            sm={6}
            md={regulation === "Reports" ? 4 : 3}
            sx={{
              ...(PurchasesFile === "PurchasedUsers" && {
                flexBasis: "100% !important",
                maxWidth: "100% !important",
              }),
            }}
          >
            <FormControl
              fullWidth
              size="small"
              disabled={pageName === "Messages" && !courseId}
            >
              <InputLabel>Select Semester</InputLabel>
              <Select
                value={semesterId || ""}
                onChange={(e) => {
                  setSemesterId(e.target.value);
                }}
                label="Select Semester"
                sx={{
                  textAlign: "left",
                  backgroundColor: "#fff",
                }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {semesters
                  .filter(
                    (sem) =>
                      !courseId ||
                      courses
                        .find((course) => course.id === courseId)
                        ?.semesters?.includes(sem.id),
                  )
                  .map((s) => (
                    <MenuItem key={s.id} value={s.id}>
                      {s.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default FilterBar;
